const H = { fontFamily: "Plus Jakarta Sans, sans-serif" };

export const LandingSection = ({ id, kicker, title, intro, accent = "#10B981", children, muted = false }) => (
  <section id={id} className={`border-t border-slate-800/80 ${muted ? "bg-[#0F172A]/40" : ""}`} data-testid={`landing-section-${id}`}>
    <div className="mx-auto max-w-6xl px-4 sm:px-6 py-16 sm:py-20">
      <p className="text-sm font-semibold tracking-[0.18em] uppercase" style={{ color: accent }}>{kicker}</p>
      <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold text-white max-w-3xl" style={H}>{title}</h2>
      {intro && <p className="mt-4 text-slate-400 max-w-3xl">{intro}</p>}
      <div className="mt-10">{children}</div>
    </div>
  </section>
);

export const FeatureCard = ({ icon: Icon, title, text, accent = "#10B981" }) => (
  <div className="rounded-2xl border border-slate-800 bg-[#111827]/80 p-5 transition-all hover:-translate-y-0.5 hover:border-[#10B981]/50">
    <div className="h-10 w-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${accent}26`, color: accent }}><Icon className="h-5 w-5" /></div>
    <h3 className="mt-4 font-semibold text-white" style={H}>{title}</h3>
    <p className="mt-2 text-sm text-slate-400">{text}</p>
  </div>
);

// Badge testuale: solo testo e colore di riferimento #0866FF; nessun logo o marchio Meta. Elemento distinto dal marchio NOUVELLE WHATSAPP.
export const MetaBadge = () => (
  <span className="inline-flex items-center gap-2 rounded-full border border-[#0866FF]/50 bg-[#0866FF]/15 px-3.5 py-1.5 text-sm font-semibold text-[#9CC2FF]" data-testid="landing-meta-badge">
    <span className="h-2 w-2 rounded-full bg-[#0866FF]" aria-hidden="true" />Meta Tech Provider
  </span>
);

// Marchio ufficiale (file originale, solo fondo bianco esterno rimosso). variant "dark" = sola parola «Nouvelle» in bianco.
const BRAND = {
  dark: { h192: "/brand/nouvelle-whatsapp-dark-h192.png", h256: "/brand/nouvelle-whatsapp-dark-h256.png" },
  light: { h192: "/brand/nouvelle-whatsapp-h192.png", h256: "/brand/nouvelle-whatsapp-h256.png" },
};
export const BrandLogo = ({ variant = "dark", size = "h192", className = "", testId = "landing-brand-logo" }) => (
  <img src={BRAND[variant][size]} alt="NOUVELLE WHATSAPP" width={size === "h256" ? 206 : 155} height={size === "h256" ? 256 : 192} decoding="async" className={`block w-auto ${className}`} data-testid={testId} />
);

export const ChannelCard = ({ kicker, title, text, border }) => (
  <div className={`rounded-2xl border ${border} !bg-[#0F172A] p-4`}>
    <p className="text-[11px] uppercase tracking-[0.12em] text-slate-500">{kicker}</p>
    <p className="mt-1 font-semibold text-white">{title}</p>
    <p className="text-xs text-slate-400 mt-1">{text}</p>
  </div>
);
